import { TimeInput } from "@mantine/dates";

const TimeInputComp = ({
  label,
  value,
  onChange,
  placeholder,
  isRequired,
  disabled,
}) => {
  return (
    <TimeInput
      label={label}
      placeholder={placeholder}
      value={value || null}
      onChange={onChange}
      withAsterisk={isRequired}
      disabled={disabled}
      clearable
    />
  );
};

export default TimeInputComp;
